import reducers from "./Reducers";
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import {applyMiddleware, createStore} from 'redux'


const store = createStore( reducers, composeWithDevTools(applyMiddleware(thunk)))

export default store